import type { FaireProductEntity } from "../../entity_types/product";

export const p_5zasnmgk5u: FaireProductEntity = {
  token: "p_5zasnmgk5u",
  type: "product",
  name: "Vera Fairisle Sweater - Juniper (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/c4d6d8d19d052645371215caaa382abd9fbee6a000f1bee3a83e2ac00ae29782.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e258affaf0fcc69e62499f130e946198d3f474413d4727d9c8609b0ebabbb1bd.jpeg",
    "https://cdn.faire.com/fastly/376a2fe79358bb3374fe09d857170af989dc8122da212412e6c785c64b75b351.jpeg",
    "https://cdn.faire.com/fastly/52a92e5b852b974a6d9945d14b9b122424102ceaac160cdd3d93e7ad35bb3d46.jpeg",
    "https://cdn.faire.com/fastly/8d0b33c4901ac376c09c4d7a61774c6dcaed399ae802c99db37479d2f0df6650.jpeg",
    "https://cdn.faire.com/fastly/fbba66539499f5101c5f7bc0a7e39f060a3565258c0513def7cb58028e2c6699.jpeg",
    "https://cdn.faire.com/fastly/9d9808ea41df39f42c9c51d531db6ca9a9bd7f5746e4d01e3c6d03e758e05b01.jpeg",
    "https://cdn.faire.com/fastly/6ada9b9dc33b813c0c82f69e046e4ec09183eb9d014e7df4f7245001c58e1456.jpeg"
  ],
  priceDollars: 116.1,
  description: "A modern nod to a timeless knit tradition. The Vera Fairisle Sweater reimagines a classic motif through graphic patternwork meets ultra-soft alpaca warmth.\n\n• 89% Alpaca 11% Polyamide\n• Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity\n• Classic fit with a subtle crop",
  tags: [],
  msrpDollars: 258,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:22.260Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
